import { env } from "../appConfig";

let cachedConfig = null;

function requireEnv(name) {
  const value = env[name];
  if (value === undefined || value === null || value === "") {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

function envFlag(name) {
  return env[name] === true || env[name] === "true";
}

function optionalEnv(name) {
  return env[name] || "";
}

export function shouldCallAgentRegisterApis() {
  return envFlag("AGENT_REGISTER_CALL_APIS");
}

export function getAgentRegisterConfig() {
  if (cachedConfig) {
    return cachedConfig;
  }

  const accessApiUrl =
    env.ACCESS_API_URL || env.REACT_APP_PROFILE_ORG_BASE_URL;

  if (!accessApiUrl) {
    throw new Error(
      "Missing ACCESS_API_URL or REACT_APP_PROFILE_ORG_BASE_URL for agent registration."
    );
  }

  cachedConfig = {
    accessApiUrl,
    ttsWebserviceUrl: requireEnv("TTS_WEBSERVICE_URL"),
    notificationApiUrl: requireEnv("NOTIFICATION_API_URL"),
    tempRegisterPassword: requireEnv("TEMP_REGISTER_AGENT_PASS"),
    verifyEmailTemplateIdEn: requireEnv("VERIFY_EMAIL_TEMPLATE_ID_EN"),
    verifyEmailTemplateIdFr: requireEnv("VERIFY_EMAIL_TEMPLATE_ID_FR"),
    ttsUsername: requireEnv("TTS_USERNAME"),
    ttsPassword: requireEnv("TTS_PASSWORD"),
    ttsRequest: requireEnv("TTS_REQUEST"),
    ttsTimeoutMs: Number(requireEnv("TTS_TIMEOUT_MS")),
    newsletterSubscription: requireEnv("AGENT_REGISTER_NEWSLETTER_SUBSCRIPTION"),
    allowPushNotifications: requireEnv("AGENT_REGISTER_ALLOW_PUSH"),
    defaultInterests: optionalEnv("AGENT_REGISTER_DEFAULT_INTERESTS")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean),
    verificationTokenLength: Number(requireEnv("VERIFICATION_TOKEN_LENGTH")),
    defaultLanguage: requireEnv("AGENT_REGISTER_DEFAULT_LANGUAGE"),
    defaultAgencyPhone: requireEnv("DEFAULT_AGENCY_PHONE"),
    callApis: envFlag("AGENT_REGISTER_CALL_APIS"),
  };

  return cachedConfig;
}

export function getDefaultAgencyPhone() {
  return optionalEnv("DEFAULT_AGENCY_PHONE").replace(/\D/g, "");
}

export function getDefaultRegistrationLanguage() {
  return optionalEnv("AGENT_REGISTER_DEFAULT_LANGUAGE") || "en";
}

export function getVerificationEmailTemplateId(language) {
  const config = getAgentRegisterConfig();
  const lang = language.toLowerCase().slice(0, 2);
  return lang === "fr"
    ? config.verifyEmailTemplateIdFr
    : config.verifyEmailTemplateIdEn;
}

export function resetAgentRegisterConfigCache() {
  cachedConfig = null;
}
